import React from 'react';
import { Column } from '@ant-design/plots';

const Downloadsbycampaign = (props) => {
    const data = [
    ];
    props.campaignData.forEach((value)=>{

      var campaignName = value.position;
      var length = 9;
      var trimmedCampaignName= campaignName.substring(0, length)+'...';

      data.push(
        {
          'CampaignTrimmed':trimmedCampaignName,
          'Campaign':value.position,
          'Downloads':parseInt(value.downloads),
        }
      )
    })

  const config = {
    data,
    point: {
      size: 5,
      shape: 'diamond',
      style: {
        fill: 'white',
        stroke: '#2593fc',
        lineWidth: 2,
      }},
    xField:'CampaignTrimmed',
    yField:'Downloads',
    // label: {
    //   position: 'top',
    //   style: {
    //     fill: '#000000',
    //     // fontSize: 12
    //   },
    // },
    meta:false,
    color:'#667AFF',
    columnStyle: {
      radius: [20, 20, 20, 20],
      width:10,
      lineWidth:1
    },
    isStack: true,
    xAxis: {
      label: {
        autoRotate: true,
        autoHide: false,
        autoEllipsis: true,
        style: {
          fontSize: 10
        },
      },
    },
    style:{
      // width:auto,
      height:260
    },
    minColumnWidth: 15,
    maxColumnWidth: 15,
    scrollbar: {
      type: 'horizontal',
      style: {
        trackColor: '#F0FAFF',
        thumbColor: '#D7F2FF'
      },
    },
    tooltip: {
      showTitle: false,
      fields: ['Campaign', 'Downloads'],
    }
  };
  if(data.length>0){
    return <Column {...config} />;
  }

};

export default Downloadsbycampaign;
